module.exports = {
	"Notify": {
		"err": "Error",
		"errorMsg": "Net error. Please try again later",
		"suc": "Successful"
	},
	"Navigator": {
		"profile": "Profile",
		"signOut": "Sign out",
		"signIn": "Sign in",
		"signOutTips": "Are you sure?",
		"tip": "Tips",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"lang": "Language",
		"changeLang": "Switching language",
		"appName": "AI Merchant"
	},
	"Functional": {
		"save": "Save",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"publish": "Publish",
		"clear": "Clear All",
		"download": "Download",
		"upload": "Upload device",
		"next": "Next",
		"back": "Back",
		"help": "Help",
		"on": "On | ON",
		"off": "Off | OFF",
		"create": "Create",
		"delete": "Delete",
		"all": "All | All Stores | All Status | All Types | Select All",
		"comingSoon": "Coming Soon.",
		"controlPanel": "Control panel",
		"more": "More | More Info",
		"yes": "Yes | YES",
		"no": "No | NO",
		"reload": "Reload"
	},
	"Date": {
		"dateRange": "Recent 7 days | Recent 30 days | Recent 12 months",
		"today": "Today",
		"openTime": "Open time",
		"closeTime": "Close time",
		"placeholder": "Please choose date range"
	},
	"Chart": {
		"numberOfCustomers": "Number of customers",
		"numberOfOrder": "Number of orders",
		"arpcByOutlet": "ARPC by store",
		"revenue": "Revenue",
		"trxAmount": "Transaction amount",
		"transactionByChannel": "Transaction by channel",
		"channelPercentage": "Channel percentage",
		"outletPercentage": "Store percentage",
		"statusPercentage": "Status percentage",
		"customerGrowthChart": "Customers growth chart",
		"newCustomers": "New customers",
		"retention": "Retention",
		"customerCategories": "Customer categories",
		"customerStatus": "Customer Status",
		"customerFrequency": "Customer frequency",
		"customerContribution": "Customer contribution",
		"arpcByGender": "ARPC by Gender",
		"arpcByProduct": "ARPC by Product",
		"outletPerChannel": "Per channel",
		"transactionsByOutlet": "Transactions by store",
		"RefundByOutlet": "Refund by store",
		"ReversalByOutlet": "Reversal by store"
	},
	"Tab": {
		"generalStatus": "General status",
		"byChannel": "By channel",
		"percentage": "Percentage",
		"newCustomers": "New customers",
		"customerCategories": "Customer categories",
		"arpc": "Average revenue per customer(ARPC)",
		"customerMap": "Customer map",
		"transactions": "Transactions",
		"outletPercentage": "Percentage"
	},
	"Button": {
		"createNewCoupon": "+ Create new coupon",
		"addNewOutlet": "Add new store",
		"chooseCouponTemplate": "Choose Coupon Template",
		"backToTemplate": "Back to template selection",
		"saveCoupon": "Save coupon",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"refund": "Refund"
	},
	"Placeholder": {
		"TableSearch": "Please type id",
		"OutletSearch": "Store name , Address , Contact person , Mobile number",
		"AccountSearch": "Username , Name , Mobile number , Email"
	},
	"Step": {
		"Coupons": "CHOOSE COUNTRIES | CHOOSE TEMPLATE | EDIT COUPONS | CHOOSE STORES"
	},
	"Country": {
		"title": "Choose coupons distribution countries",
		"China": "China",
		"Australia": "Australia",
		"Indonesia": "Indonesia",
		"Malaysia": "Malaysia",
		"Singapore": "Singapre",
		"SouthKorea": "South Korea",
		"Thailand": "Thailand"
	},
	"Week": {
		"sunday": "Sunday",
		"monday": "Monday",
		"tuesday": "Tuesday",
		"wednesday": "Wednesday",
		"thursday": "Thursday",
		"friday": "Friday",
		"saturday": "Saturday"
	},
	"Table": {
		"id": "ID",
		"actions": "Actions",
		"view": "View | Detail | Details",
		"stop": "Stop",
		"update": "Update",
		"publish": "Publish",
		"upgrade": "Upgrade",
		"edit": "Edit",
		"resetPassword": "Reset Password",
		"permissions": "Permissions"
	},
	"Views": {
		"401": {
			"title": "401",
			"cnt1": "Sorry!",
			"cnt2": "You have no access rights",
			"btn1": "",
			"btn2": "Go to Dashboard"
		},
		"404": {
			"title": "404",
			"cnt1": "Sorry",
			"cnt2": "The page could not be found",
			"btn1": "Back to prev",
			"btn2": "Go to Dashboard"
		},
		"500": {
			"title": "500",
			"cnt1": "Sorry!",
			"cnt2": "The service is temporarily unresponsive",
			"btn1": "Refresh",
			"btn2": "Go to Dashboard"
		},
		"Login": {
			"msg": "Please type your name and password again.",
			"login": "Login",
			"loading": "Loading",
			"id": "ID",
			"pwd": "Password",
			"captcha": "Captcha"
		},
		"Dashboard": {
			"welTitle": "Congratulations! You have successfully activate your account!",
			"welCnt": "You can download the QR code via merchant portal. Related marketing materials and QR code will be delivered to your store within 3-5 working days."
		},
		"Transactions": {
			"filter": {
				"id": "Please type Transaction ID",
				"mid": "Please type Merchant ID",
				"mname": "Please type Merchant name"
			},
			"table": {
				"id": "Transaction ID",
				"date": "Transaction time",
				"amount": "Settlement amount",
				"realAmount": "Total amount",
				"status": "Payment status",
				"outlet": "Store",
				"posID": "POS ID",
				"remark": "Remark",
				"cAmount": "Order amount",
				"customer": "Customer",
				"posUsername": "POS Username"
			},
			"downloadFileName": "transaction"
		},
		"TrxViewDeital": {
			"table": {
				"id": "ID",
				"outletId": "Store ID",
				"merchantId": "Merchant ID",
				"trxId": "Transaction ID",
				"settleAmount": "Settlement amount",
				"realAmount": "Total amount",
				"currency": "Currency",
				"createTime": "Create time",
				"createLocalTime": "Create local time",
				"deviceId": "Device ID",
				"status": "Status",
				"subType": "Sub Type",
				"remark": "Remark",
				"payTrxId": "Pay transaction ID",
				"payChannel": "Payment channel",
				"customer": "Customer",
				"fee": "Customer service fee",
				"customerAmount": "Order amount",
				"settleTime": "Settlement time",
				"refundRecord": "Refund record",
				"refundStatus": "Refund status",
				"requestForRefund": "Request for refund",
				"refunded": "Refunded",
				"refundFailed": "Refunded failed",
				"appTime": "Application time",
				"completeTime": "Completed time",
				"refundAmount": "Refunded amount",
				"refund": "Refund",
				"refundAbleAmount": "Refundable amount",
				"finalAmount": "Final amount",
				"cRate": "Customer rate",
				"mRate": "Merchant rate",
				"discount": "Discount",
				"t1": "Basic Information",
				"posId": "POS ID",
				"cashier": "Cashier Username"
			},
			"tips": {
				"title": "Refund",
				"cnt": "This refund request cannot be cancelled. Are you sure to proceed?",
				"placeholder": "Refund password"
			},
			"transferNameList": "0 | Transfer Pending | Transfer Completed | Transfer Failed"
		},
		"Refund": {
			"table": {
				"rTime": "Refund time",
				"trxId": "Transaction ID",
				"rAmount": "Refunded amount",
				"rStatus": "Refund status",
				"customer": "Customer",
				"remark": "Remark",
				"store": "Store",
				"posId": "Pos ID"
			},
			"filter": {
				"trxId": "Transaction ID",
				"customer": "Customer"
			},
			"button": {
				"refund": "Pending refunds"
			},
			"mask": {
				"title": "Pending refunded amount",
				"name": "Agency name",
				"amount": "Amount",
				"cnt": "Your settlement has been suspended. Please transfer the above amount to the agency as soon as possible to resume the settlement."
			},
			"downloadFileName": "refunds"
		},
		"RefundDetail": {
			"form": {
				"trxId": "Transaction ID",
				"cTime": "Application time",
				"ptId": "Pay Transaction ID",
				"pType": "Payment type",
				"customer": "Customer",
				"fee": "Customer service fee",
				"rAmount": "RefundAmount",
				"settled": "To be settled",
				"sTime": "Settlement time",
				"rComplete": "Refund status",
				"completeTime": "Completed time",
				"failedTime": "Failed time"
			}
		},
		"Customers": {
			"checkbox": {
				"all": "All",
				"customerCategorization": "Customer Categorization",
				"activeCustomers": "Active customers | Inactive customers | Lost customers",
				"frequencyCustomers": "High frequency customers | Mid frequency customers | Low frequency customers",
				"contributionCustomers": "High contribution customers | Mid contribution customers | Low contribution customers"
			},
			"table": {
				"id": "ID",
				"name": "Name",
				"mobile": "Mobile number",
				"gender": "Gender",
				"joinDate": "Join date",
				"totalSpending": "Total spending",
				"lastVisitDate": "Last visit date",
				"averageSpending": "Average spending"
			}
		},
		"Coupons": {
			"CNC": "Create New Coupon",
			"AC": "Active Coupon",
			"IC": "Invaild Coupon",
			"redeem": "redeemed",
			"invalid": "Invalid",
			"none": "No data"
		},
		"CouponsTips": {
			"title": "In our system, you can easily publish your store coupon to all connected channels.",
			"tip1": "If you would like to enable this feature",
			"tip2": "please contact your MA"
		},
		"ChooseTemplate": {
			"productDiscount": "Product discount",
			"storeWideOff": "Store-wide % off",
			"freeGift": "Free gift",
			"cash": "Cash",
			"subtitle": "Coupon",
			"choose": "Choose this template"
		},
		"CouponAgreement": {
			"btn": "I agree",
			"title": "Agreement"
		},
		"ProductDiscount": {
			"subtitle": "Create product coupon",
			"form": {
				"title": "Coupon title | Product name | Product description | Original percentage | Usage instructions",
				"description": "After discount $ {discountValue}, customers save $ {saveValue}"
			}
		},
		"Conditions": {
			"payOnline": "Pay online",
			"payOnlineDescription": "Only for product discount coupon",
			"checkboxTitle": "Can be used for",
			"checkbox": "In store purchase | Delivery order"
		},
		"Settlement": {
			"table": {
				"tDate": "Transaction date",
				"sAmount": "Settlement amount",
				"sStatus": "Settlement status",
				"sTime": "Settlement time",
				"cTime": "Upload time"
			},
			"filter": {
				"status": "Please choose settlement status"
			},
			"transferOption": {
				"initial": "Initial",
				"pending": "Pending",
				"processing": "Processing",
				"successful": "Successful",
				"failed": "Failed",
				"refuse": "Refuse"
			},
			"downloadFileName": "statement | settlement"
		},
		"Review": {
			"title": "Coupon content info | Coupon condition info"
		},
		"Outlets": {
			"table": {
				"id": "ID",
				"name": "Store name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"address": "Address",
				"contact": "Contact person",
				"phone": "Mobile number"
			}
		},
		"AddNewOutlet": {
			"form": {
				"name": "Name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"place": "Set Postion",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude"
			}
		},
		"ViewOutletDetail": {
			"table": {
				"name": "Store name",
				"address": "Address",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude",
				"country": "Country",
				"city": "City",
				"state": "State",
				"pt": "Upload photos of store",
				"p1": "Shop inside photo",
				"p2": "Shop outside photo"
			}
		},
		"Reconciliation": {
			"table": {
				"date": "Date",
				"amount": "Amount",
				"type": "Type",
				"status": "Status",
				"outlet": "Store",
				"posID": "POS ID"
			}
		},
		"Devices": {
			"table": {
				"outlet": "Store",
				"posName": "POS name",
				"pay": "Alipay | Apple pay | Android pay | Samsung pay | Grab pay"
			}
		},
		"Accounts": {
			"table": {
				"username": "Username",
				"name": "Name",
				"mobile": "Mobile number",
				"email": "Email",
				"status": "Status",
				"lastTime": "Last login time",
				"createdAt": "Created at",
				"updatedAt": "Updated at",
				"admin": "Admin?"
			},
			"btn": {
				"add": "Create new account"
			}
		},
		"AddNewAccount": {
			"form": {
				"username": "Username",
				"name": "Name",
				"phone": "Mobile number",
				"email": "Email",
				"admin": "Admin?",
				"password": "Password",
				"status": "Status"
			}
		},
		"Password": {
			"title": "Modify Password",
			"old": "Old password",
			"new": "New password",
			"rNew": "Confirm new password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"RefundPassword": {
			"title": "Modify refund password",
			"old": "Current refund password",
			"new": "New refund password",
			"rNew": "Confirm refund password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"QrCode": {
			"title": "Merchant QR code",
			"storeTitle": "Store QR code",
			"download": "Download"
		},
		"PaymentChannel": {
			"channel": "Channel enable | Channel disable",
			"subTitle": "Customer service fee rate",
			"CBSF": "Customer Bear the Service Fee",
			"SFR": "Service fee rate",
			"MBSF": "Merchant Bear the service fee",
			"err": "Customer service fee cannot be set higher",
			"than": "than",
			"cancel": "Cancel",
			"save": "Save",
			"msg": "Customer service fee cannot be set higher than",
			"msg2": "Customer service fee cannot be lower than 0%"
		},
		"Analytics": {
			"Transaction": {
				"generalStatus": "General status",
				"byChannel": "By channel",
				"percentage": "Percentage"
			},
			"Customer": {
				"generalStatus": "General status",
				"customerCategories": "Customer categories",
				"ARPC": "Average revenue per customer (ARPC)",
				"t1h1": "Category",
				"t1h2": "Last puchase time (days ago)",
				"t1h3": "Number of customers",
				"t2h1": "Category",
				"t2h2": "Total purchase times",
				"t2h3": "Percentage of customers",
				"t3h1": "Category",
				"t3h2": "Average purchase amount ($)",
				"t3h3": "Percentage of customers"
			},
			"Store": {
				"trx": "Transactions",
				"percent": "Percentage"
			},
			"Customers": {
				"selectDescription": "<strong>New customer definition </strong>The payment on that day is the first payment within",
				"tableStatus": {
					"title": "Category | Last purchase times(days ago) | Number of customers",
					"midField": "last payment time"
				},
				"tableFrequency": {
					"title": "Category | Total purchase times | Percentage of customers",
					"midField": "purchase times"
				},
				"tableContribution": {
					"title": "Category | Average purchase amount($) | Percentage of customers",
					"midField": "average purchase amount"
				},
				"tableCategorisation": {
					"selector": "All | Active Customers | Inactive Customers | Lost Customers",
					"title": "Low Frequency Customers | Mid Frequency Customers | High Frequency Customers",
					"titleColumn": "Low contribution customers | Mid contribution customers | High contribution customers"
				}
			}
		},
		"PaymentChannels": {
			"table": {
				"channel": "Channel",
				"status": "Status"
			},
			"subtitle": "Activate more payment channels"
		},
		"ActivateChannels": {
			"form": "App ID | Private key | Business registration document",
			"formDescription": "Please upload your business registration document.",
			"agree": "I agree with the <a>terms and conditions</a>"
		},
		"ChooseCoupon": {
			"example": "Example",
			"title": "Which coupon do you want to create"
		},
		"AddCoupon": {
			"type": "Coupon type",
			"f1": "Discount",
			"f2": "Name",
			"f3": "Valid time",
			"month": "1 month | 3 months",
			"placeholder": "Choose coupon's name",
			"t1": "Storewide % off",
			"t1f1": "Storewide | Off",
			"t2f1": "Off with | Spend",
			"t3f1": "Off with | Spend",
			"r1": "1.",
			"r2": "2. Coupon valid time is ",
			"r3": "3. Total amount of coupon is 1000",
			"r4": "4. Each coupon can only be redeemed once",
			"r5": "5. The coupon must be presented at cashier before payment to enjoy this offer",
			"r6": "6. The management reserves the right to amend the offer without prior notice",
			"tip": "Are you sure to publish the coupon",
			"rules": "Rules",
			"msg1": "Please enter an integer for percentage discount.",
			"msg2": "Please enter an integer between 1 and 99.",
			"msg3": "Oops! Currently, we only support less than 10,000 for minimum spending setting.",
			"msg4": "Please enter an positive number for minimum spending.",
			"msg5": "Please enter an positive number for amount discount.",
			"msg6": "Please enter an integer for minimum spending.",
			"msg7": "Please enter an integer for amount discount.",
			"msg8": "Please make sure your discount amount is less than your minimum spending.",
			"msg9": "Please input coupon discount before publish.",
			"msg10": "Please complete the value."
		},
		"Agreement": {
			"title": "Settlement Period"
		},
		"Contract": {
			"agree": "I Agree",
			"contact": "Contact MA",
			"info": "Contract confirmation",
			"cnt": "I have read through the contract and agree with it",
			"tip": "Contact",
			"mail": "E-mail",
			"phone": "Phone"
		},
		"ResetPwd": {
			"t1": "Reset Password",
			"t2": "Reset Refund Password",
			"err": "Not the same password"
		},
		"ServiceFee": {
			"t": "Merchant service fee rate",
			"st": "Customer Bear the Service Fee",
			"r": "Service fee rate",
			"mf": "Merchant Bear the Service Fee",
			"sf": "Customer service fee cannot be set higher"
		},
		"Invoices": {
			"in": "Invoice number",
			"amount": "Amount",
			"gst": "GST",
			"tAmount": "Total amount",
			"month": "month",
			"placeholder": "Select month"
		}
	},
	"pageTitle": {
		"401": "401",
		"404": "404",
		"500": "500",
		"login": "Login",
		"dashboard": "Dashboard",
		"transactions": {
			"self": "Transactions",
			"view": "View transaction detail"
		},
		"customers": "Customers",
		"outlets": {
			"self": "Stores",
			"add": "Add new store",
			"view": "View store detail",
			"update": "Edit store"
		},
		"analytics": {
			"self": "Analytics",
			"trx": "Transactions",
			"customers": "Customers",
			"outlets": "Stores"
		},
		"reconciliation": "Reconciliation",
		"accounts": {
			"self": "Accounts",
			"add": "Add new account",
			"update": "Update account"
		},
		"refunds": {
			"self": "Refunds",
			"view": "Refund details"
		},
		"settings": {
			"self": "Settings",
			"payment": "Payment channel",
			"pwd": "Modify password",
			"refundPwd": "Modify refund password",
			"bank": "Bank",
			"qrcode": "QrCode"
		},
		"onBoarding": {
			"reset": "Reset password",
			"agreement": "Agreement",
			"contract": "Contract",
			"serviceFee": "Customer service fee setting"
		},
		"coupons": {
			"self": "Coupons",
			"choose": "Choose coupon",
			"add": "Add coupon",
			"edit": "Update coupon",
			"view": "View coupon detail",
			"agreement": "Agreement",
			"tips": "Tips"
		},
		"invoices": "Invoices",
		"settlements": "Settlements",
		"contract": "Contract"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/en/index.json
// module id = 1184
// module chunks = 1